/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'uikit/buttons';
import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/appHeaderActions.module.scss';

const AppHeaderActions = ({
  appHeaderActions,
}) => (
  <ul className={styles.element}>
    {appHeaderActions.map((action) => {
      const { hasTooltip, tooltipText, ...other } = action;
      const Element = hasTooltip ? Tooltip : 'li';

      const TooltipChildElement = Element === Tooltip ? 'span' : React.Fragment;

      return (
        <Element key={action.id} content={tooltipText} placement="right">
          {/* Tooltips require a span here otherwise it doesn't show when button is disabled */}
          <TooltipChildElement>
            <Button {...other} />
          </TooltipChildElement>
        </Element>
      );
    })}
  </ul>
);

AppHeaderActions.propTypes = {
  appHeaderActions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default React.memo(AppHeaderActions);
